<template>
  <div class="centered-container">
    <v-form ref="form" v-model="valid" >
      <v-card class="elevation-12">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t("passwordForm.authorization") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field 
            prepend-icon="mdi-lock" 
            name="password" 
            id="password" 
            :type="showPassword ? 'text' : 'password'" 
            v-model="password" 
            :rules="passwordRules"
            @keydown="inputHandler" 
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword" 
            :key="$i18n.locale"
            />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" 
            :disabled="!valid" 
            @click="() => handlePassword()"
          >
            {{ $t("passwordForm.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { notifyError } from '../../services/notifications';

export default {
  name: 'PasswordForm',
  data() {
    return {
      password: '',
      valid: false,
      permissibleChars: /^[A-Za-z0-9+!#$@\-_.]+$/,
      showPassword: false,
    };
  },
  computed: {
    passwordRules() {
      return [
        (v) => !!v || this.$t('passwordForm.passwordIsRequired'),
        (v) => v.match(this.permissibleChars) !== null || this.$t('resetPasswordForm.unaccepttableSymb'),
      ];
    }
  },
  methods: {
    inputHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        // можно отправлять данные нажатием на Enter
        e.preventDefault();
        if (this.password) this.handlePassword();
      }
    },
    async handlePassword() {
      try {
        // сначала сохраняем пароль, тк он используется во всех запросах к api/settings
        this.$store.commit('setAdminPassword', this.password);
        const response = await this.$axios.adminSettings.adminAuth();
        this.$store.commit('setAdminSettings', response.data);
        this.$router.push('/settings');
        this.$emit('close');
      } catch (error) {
        if (error.response?.data?.errorType === 'WRONG_CREDITS') {
          notifyError('', this.$t('passwordForm.wrongPassword'));
        } else {
          notifyError('', this.$t('passwordForm.unknownError'));
        }
      }
    },
    closeForm() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
  .centered-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    width: 100%;
    max-width: 400px;
  }
</style>